import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import ProcessingAgencyOrganizedUnitConfigMasterModalPage from '../../../containers/masters/ProcessingAgencyOrganizedUnitConfig/ProcessingAgencyOrganizedUnitConfigMasterModalPage'
import InputSelect from '../../commons/form/InputSelect'
import MapSectionsMasters from '../../../util/map-sections-masters'

class ProcessingAgencyOrganizedUnitConfigMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchOrganizedUnitsAll()
    this.props.actions.fetchProcessingAgencyCommunicationServices()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchProcessingAgencyOrganizedUnitConfigList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchProcessingAgencyOrganizedUnitConfigList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleProcessAgencyCommunicationServiceIdChange (value) {
    this.setState({ filter: { ...this.state.filter, processAgencyCommunicationServiceId: value } })
    if (value) {
      this.props.actions.fetchProcessingAgencyOrganizedUnitConfigList({
        ...this.state.filter,
        ...this.props.filter,
        processAgencyCommunicationServiceId: value
      })
    }
  }

  render () {
    const {
      t, processingAgencyOrganizedUnitConfigs, pagesCount, filter, processingAgencyOrganizedUnitConfigsCount,
      filter: { page },
      actions: { showProcessingAgencyOrganizedUnitConfigModal },
      combos: { organizedUnitsAllCombo, processingAgencyCommunicationServices }
    } = this.props
    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'processingAgencyOrganizedUnitConfigMasterPage' })
    const tKey = 'MASTERS.PROCESSING_AGENCY_ORGANIZED_UNIT_CONFIG.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    return (
      <div id="processingAgencyOrganizedUnitConfigMaster" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => showProcessingAgencyOrganizedUnitConfigModal(true)}
              disabled={!this.state.filter?.processAgencyCommunicationServiceId}
            >
              {t(`${tKey}ADD`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.processAgencyCommunicationServiceId"
                colSm={4}
                controlLabel={t(`${tKey}COMMUNICATION_SERVICE`)}
                placeholder={t(`${tKey}COMMUNICATION_SERVICE`)}
                valueKey="id"
                labelKey="value"
                options={processingAgencyCommunicationServices}
                onInputChange={(value) => this.handleProcessAgencyCommunicationServiceIdChange(value)}
              />
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              { !this.state.filter?.processAgencyCommunicationServiceId || processingAgencyOrganizedUnitConfigs.length !== 0 &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('organizedUnitId') }}>
                        {t(`${tKey}ORGANIZED_UNIT`)}
                        <i className={this.getSortIcon('organizedUnitId')} />
                      </th>
                      <th onClick={() => { this.changeOrder('user') }}>
                        {t(`${tKey}USER`)}
                        <i className={this.getSortIcon('user')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.filter?.processAgencyCommunicationServiceId &&
                    processingAgencyOrganizedUnitConfigs &&
                    processingAgencyOrganizedUnitConfigs.map((processingAgencyOrganizedUnitConfig, idx) => {
                      return (
                        <tr key={idx} className={processingAgencyOrganizedUnitConfig.isDeleted ? 'is-deleted' : ''}>
                          <td>{ organizedUnitsAllCombo.find(x => x.id === processingAgencyOrganizedUnitConfig.organizedUnitId).value }</td>
                          <td>{processingAgencyOrganizedUnitConfig.user}</td>
                          <td className='actions'>
                            {!processingAgencyOrganizedUnitConfig.isDeleted && (
                              <div>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => showProcessingAgencyOrganizedUnitConfigModal(true, processingAgencyOrganizedUnitConfig)}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => this.props.actions.deleteProcessingAgencyOrganizedUnitConfig(processingAgencyOrganizedUnitConfig.processingAgencyOrganizedUnitConfigId, this.state.filter.processAgencyCommunicationServiceId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            )}
                          </td>
                        </tr>)
                    })}
                  </tbody>
                </Table>
              }
              {this.state.filter?.processAgencyCommunicationServiceId &&
              (processingAgencyOrganizedUnitConfigs === null ||
              processingAgencyOrganizedUnitConfigs === undefined ||
              processingAgencyOrganizedUnitConfigs.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              { !this.state.filter?.processAgencyCommunicationServiceId || processingAgencyOrganizedUnitConfigs.length !== 0 &&
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={processingAgencyOrganizedUnitConfigsCount}
                    onSelectAction={(value) => this.props.actions.fetchProcessingAgencyOrganizedUnitConfigList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
              }
            </div>
          </div>
        </div>
        <ProcessingAgencyOrganizedUnitConfigMasterModalPage processAgencyCommunicationServiceId={this.state.filter.processAgencyCommunicationServiceId} OUsAssigned={processingAgencyOrganizedUnitConfigs.map(x => x.organizedUnitId)}/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listProcessingAgencyOrganizedUnitConfig'
})(ProcessingAgencyOrganizedUnitConfigMaster)
